/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TravelPreferencesResponse
 */
export interface TravelPreferencesResponse {
    /**
     * User-edited travel preferences (free-text)
     * @type {string}
     * @memberof TravelPreferencesResponse
     */
    userPreferences?: string | null;
    /**
     * LLM-learned traveler profile (preferences extracted from conversations)
     * @type {string}
     * @memberof TravelPreferencesResponse
     */
    travelerProfile?: string | null;
    /**
     * Auto-generated traveler profile summary (read-only)
     * @type {string}
     * @memberof TravelPreferencesResponse
     */
    autoProfileSummary?: string | null;
    /**
     * When the auto-generated profile was last refreshed
     * @type {Date}
     * @memberof TravelPreferencesResponse
     */
    generatedAt?: Date | null;
}

/**
 * Check if a given object implements the TravelPreferencesResponse interface.
 */
export function instanceOfTravelPreferencesResponse(value: object): value is TravelPreferencesResponse {
    return true;
}

export function TravelPreferencesResponseFromJSON(json: any): TravelPreferencesResponse {
    return TravelPreferencesResponseFromJSONTyped(json, false);
}

export function TravelPreferencesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelPreferencesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userPreferences': json['user_preferences'] == null ? undefined : json['user_preferences'],
        'travelerProfile': json['traveler_profile'] == null ? undefined : json['traveler_profile'],
        'autoProfileSummary': json['auto_profile_summary'] == null ? undefined : json['auto_profile_summary'],
        'generatedAt': json['generated_at'] == null ? undefined : (new Date(json['generated_at'])),
    };
}

export function TravelPreferencesResponseToJSON(json: any): TravelPreferencesResponse {
    return TravelPreferencesResponseToJSONTyped(json, false);
}

export function TravelPreferencesResponseToJSONTyped(value?: TravelPreferencesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_preferences': value['userPreferences'],
        'traveler_profile': value['travelerProfile'],
        'auto_profile_summary': value['autoProfileSummary'],
        'generated_at': value['generatedAt'] == null ? value['generatedAt'] : value['generatedAt'].toISOString(),
    };
}

